import styled from 'styled-components'

import vars from 'scss/variables.js'

const { colorGrey7, white } = vars

export const Container = styled.div`
  margin-bottom: 30px;
  padding-left: 8px;

  ${({ variation }) =>
    variation === 'category' &&
    `
    display: flex;
    justify-content: center;

    p {
      font-size: 16px;
      color: ${white};
      font-weight: 600;

      strong {
        color: ${white};
        font-size: 16px;
      }
    }
    `}
`

export const Text = styled.p`
  color: ${colorGrey7};
  font-size: 14px;
  font-weight: 500;
  line-height: normal;

  .theme--blackfair & {
    color: ${white};
  }
`

export const Title = styled.strong`
  font-weight: 500;
  margin-right: 4px;
`
